import { ID_PREFIX_EFFECTS, CHANCE_OF_EFFECT } from './FrameSvgConstants'
import EffectTypes from '../assets/frametraits/effect_types_ids.json'
export const effectStyleForTrait = (effectStyle = 0) => {
  return effectStyle <= CHANCE_OF_EFFECT
    ? ID_PREFIX_EFFECTS.concat(effectStyle % Object.keys(EffectTypes).length)
    : null
}
